import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const l = () => /* @__PURE__ */ o.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    d: "M6.705.33C6.915.119 7.202 0 7.5 0h9c.298 0 .585.119.796.33l6.375 6.375c.21.21.329.497.329.795v9c0 .298-.119.585-.33.796l-6.375 6.375c-.21.21-.497.329-.795.329h-9c-.298 0-.585-.119-.795-.33L.33 17.296A1.13 1.13 0 0 1 0 16.5v-9c0-.298.119-.585.33-.795zm1.261 1.92L2.25 7.966v8.068l5.716 5.716h8.068l5.716-5.716V7.966L16.034 2.25zM12 6c.621 0 1.125.504 1.125 1.125v5.25a1.125 1.125 0 0 1-2.25 0v-5.25C10.875 6.504 11.379 6 12 6m0 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    fill: "currentColor"
  }
) });
export {
  l as S
};
